/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Protocol_Field_Clothing_TightInputs */

const en_us2_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`loose clothing`)
};

const pt_br2_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`roupa larga`)
};

const es_419_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ropa holgada`)
};

const pt_pt2_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`roupa larga`)
};

const fr_fr2_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vêtements amples`)
};

const de_de2_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weite Kleidung`)
};

const it_it2_body_assessment_protocol_field_clothing_tight = /** @type {(inputs: Body_Assessment_Protocol_Field_Clothing_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abiti larghi`)
};

/**
* | output |
* | --- |
* | "loose clothing" |
*
* @param {Body_Assessment_Protocol_Field_Clothing_TightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_protocol_field_clothing_tight = /** @type {((inputs?: Body_Assessment_Protocol_Field_Clothing_TightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Protocol_Field_Clothing_TightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_protocol_field_clothing_tight(inputs)
	if (locale === "es-419") return es_419_body_assessment_protocol_field_clothing_tight(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_protocol_field_clothing_tight(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_protocol_field_clothing_tight(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_protocol_field_clothing_tight(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_protocol_field_clothing_tight(inputs)
	return en_us2_body_assessment_protocol_field_clothing_tight(inputs)
});
export { body_assessment_protocol_field_clothing_tight as "body-assessment.protocol_field.clothing_tight" }